<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">門市服務 / 餐點DM上傳</b-col>
      <b-col>
        <div class="text-right">
          <router-link :to="{ name: 'store_menu_add', params: { search: search } }" class="btn btn-normal-ptc1" tag="button" v-show="FunctionPermission===2">新增餐點DM</router-link>
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2">餐點類別：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.title" placeholder="請輸入關鍵字搜尋">
                  </div>
                  <label class="control-label col-md-2">品牌：</label>
                    <div class="col-md-4">
                      <select
                        name="queryBrandsCode"
                        class="form-control"
                        v-model="search.queryBrandsCode"
                      >
                      <option
                        v-for="x in selectListBrands"
                        v-bind:value="x.Code"
                        :key="x.Code"
                      >{{x.Text}}</option>
                      </select>
                    </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">效期區間：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="search.sdate" max="9999-12-31" @input="changeDate($event, 1)" v-on:keydown="keydownDate($event, 1)">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="search.edate" max="9999-12-31" @input="changeDate($event, 2)" v-on:keydown="keydownDate($event, 2)">
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-ptc1" @click="querysearch">查詢</button>
                    <button type="reset" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <b-tabs card class="tab_color" v-model="search.tabIndex">
              <b-tab title="上架中" @click="changeTab(0)">
                <div class="row">
                  <div class="col-lg-6">
                    <h3>餐點DM排序</h3>
                  </div>
                  <div class="col-lg-6" v-show="FunctionPermission===2">
                    <div class="float-right" v-show="!isReSort">
                      <button type="button" class="btn btn-ptc1" @click="resort" >重新排序</button>
                    </div>
                    <div class="float-right" v-show="isReSort">
                      <button type="button" class="btn btn-save" @click="save">儲存</button>
                      <button type="button" class="btn btn-clear" @click="cancel">取消</button>
                    </div>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped" :class="{ 'table-move': isReSort }">
                        <thead>
                          <tr>
                            <th>序號</th>
                            <th>圖片</th>
                            <th>餐點類別</th>
                            <th>開始日期</th>
                            <th>結束日期</th>
                            <th>狀態</th>
                            <th>異動人員</th>
                            <th>異動時間</th>
                            <th></th>
                          </tr>
                        </thead>
                        <draggable element="tbody" :options="{ 'disabled': !isReSort }" @update="dragEnd">
                          <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                            <td>{{((search.currentPage-1)*pageRows+index+1)}}</td>
                            <td><img height="140px" :src="x.ImageURL"></td>
                            <td>{{x.CategoryText}}</td>
                            <td>{{x.EnabledAt | formatDate}}</td>
                            <td>{{x.DisabledAt | formatDate}}</td>
                            <td>
                              <span v-if="x.EnabledAt.substring(0,10)>today">已排程</span>
                              <span v-else style="color:red">已上架</span>
                            </td>
                            <td>{{x.UpdatedName}}</td>
                            <td>{{x.WebUpdatedAt | formatFullDate}}</td>
                            <td>
                              <router-link v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1" v-show="!isReSort && FunctionPermission===2" tag="button" :to="{ name: 'store_menu_edit', params: { item: x, action: 1, search: search } }"><span class="fa fa-pencil-alt"></span></router-link>
                              <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1" @click="showDetail(x)"><span class="fa fa-search-plus"></span></button>
                            </td>
                          </tr>
                        </draggable>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="totalRows" v-model="search.currentPage" :per-page="pageRows" @change="changePage" v-show="!isReSort"></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab title="已下架" @click="changeTab(1)">
                <div class="row">
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                          <tr>
                            <th>序號</th>
                            <th>圖片</th>
                            <th>標題</th>
                            <th>開始日期</th>
                            <th>結束日期</th>
                            <th>異動人員</th>
                            <th>異動時間</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in items" :key="x.ID">
                            <td>{{((search.currentPage-1)*pageRows+index+1)}}</td>
                            <td><img height="140px" :src="x.ImageURL"></td>
                            <td>{{x.CategoryText}}</td>
                            <td>{{x.EnabledAt | formatDate}}</td>
                            <td>{{x.DisabledAt | formatDate}}</td>
                            <td>{{x.UpdatedName}}</td>
                            <td>{{x.WebUpdatedAt | formatFullDate}}</td>
                            <td>
                              <router-link v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1" tag="button" :to="{ name: 'store_menu_edit', params: { item: x, action: 2, search: search } }" v-show="FunctionPermission===2"><span class="fa fa-pencil-alt"></span></router-link>
                              <button v-b-tooltip.hover.top title="刪除" class="btn-circle btn-circle-ptc1" @click="showDelete(x)" v-show="FunctionPermission===2"><span class="fas fa-trash-alt"></span></button>
                              <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1" @click="showDetail(x)"><span class="fa fa-search-plus"></span></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="totalRows" v-model="search.currentPage" :per-page="pageRows" @change="changePage"></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-card>

      <!-- 預覽畫面Modal -->
      <b-modal ref="mdDetail" hide-footer hide-header>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12 block">
              <img class="bk_img" :src="md_imgUrl">
            </div>
          </div>
        </b-container>
      </b-modal>

      <!-- ReSort Check Modal -->
      <b-modal ref="mdCheck" hide-footer title="餐點DM排序變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定 {{sort_action==1? '放棄' : '儲存'}} 餐點DM排序變更 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="confirm2">確定</b-btn>
              <b-btn variant="secondary" @click="cancel2">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

      <!-- Delete Check Modal -->
      <b-modal ref="mdDelete" hide-footer title="餐點DM刪除">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定刪除餐點DM {{md_title}} ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script src="//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js"></script>
<script>
import draggable from 'vuedraggable'
import VModal from 'vue-js-modal'
import miniToastr from 'mini-toastr'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { DEFAULT_SEARCH_BRAND_CODE } from '@/constants/defaultValues.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
miniToastr.init()
export default {
  components: {
    draggable,
  },
  data () {
    return {
      sdateInvalid: false,
      edateInvalid: false,
      search: {
        title: '',
        sdate: '',
        edate: '',
        currentPage: 1,
        tabIndex: 0,
        queryBrandsCode: "MWD",
      },
      today: '',
      isReSort: false,
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      new_items: [],
      sort_action: 1,
      md_id: 0,
      md_title: '',
      md_imgUrl: undefined,
      API_URL: API_URL,
      FunctionPermission: 0,
      selectListBrands: [], // 品牌下拉選單
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F09') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
        this.$router.push({name: 'name'})
        return
    }
    var date = new Date()
    var year = date.getFullYear()
    var mon = date.getMonth() + 1
    var day = date.getDate()

    if (mon < 10) {
      mon = '0' + mon
    }
    if (day < 10) {
      day = '0' + day
    }
    this.today = year + '-' + mon + '-' + day
    this.setdate()
    var item = this.$route.params.search
    if (item !== undefined) {
      this.search = item
    }
    this.query()
    this.querySelectListBrands()
  },
  methods: {
    changeDate (e, type) {
      // 日期變更事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      // 日期輸入事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    reset () {
      this.setdate()
      this.search.title = ''
      this.sdateInvalid = false
      this.edateInvalid = false
      this.search.currentPage = 1
      this.query()
      this.search.queryBrandsCode = DEFAULT_SEARCH_BRAND_CODE
    },
    querysearch () {
      this.search.currentPage = 1
      this.query()
    },
    query (type) {
      this.isReSort = false
      var status, page, pageRows
      status = 1
      page = 1
      pageRows = 999
      var title = ''
      var sdate = '0001-01-01'
      var edate = '9999-12-31'
      if (type === 2) {
        title = ''
      } else {
        if (this.search.title !== '') {
          title = this.search.title
        }
        if (this.search.sdate !== '') {
          sdate = this.search.sdate
        }
        if (this.search.edate !== '') {
          edate = this.search.edate
        }
        if (sdate > edate) {
          miniToastr.error('請選擇正確的效期區間')
          return
        }
        if (this.sdateInvalid || this.edateInvalid) {
          miniToastr.error('日期格式輸入錯誤，請重新輸入')
          return
        }
        status = (this.search.tabIndex === 1) ? 2 : 10
        page = this.search.currentPage
        pageRows = this.pageRows
      }

      this.items = []
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/get/pagemenu/v1', {
        Title: title,
        ToPage: page,
        PerPage: pageRows,
        Sdate: sdate,
        Edate: edate,
        Status: status,
        BrandCode: this.search.queryBrandsCode,
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.items = response.data.data
            this.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.loading = false
            this.$store.commit('TOKEN', response.data.jwt)
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.pageRows * (this.search.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.pageRows > response.data.count) ? response.data.count : (this.search.currentPage * this.pageRows) >= response.data.count ? response.data.count : this.search.currentPage * this.pageRows

          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢菜單失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.loading = false
          miniToastr.error(error.message, '查詢菜單失敗')
          this.$parent.Loading = false
        })
    },
    changeTab (val) {
      this.search.currentPage = 1
      this.search.tabIndex = val
      this.query()
    },
    changePage: function (currentPage) {
      this.search.currentPage = currentPage
      this.query()
    },
    resort () {
      this.query(2)
      this.new_items = []
      this.isReSort = true
    },
    dragEnd (e) {
      this.new_items = []
      var childs = Array.from(e.to.getElementsByTagName("tr"))
      childs.forEach( (value) => {
        this.new_items.push(value.id)
      })
    },
    cancel () {
      this.sort_action = 1
      if (this.new_items.length === 0) {
        this.setdate()
        this.query()
      } else {
        this.$refs.mdCheck.show()
      }
    },
    save () {
      this.sort_action = 2
      if (this.new_items.length === 0) {
        this.setdate()
        this.query()
      } else {
        this.$refs.mdCheck.show()
      }
    },
    cancel2 () {
      this.$refs.mdCheck.hide()
      if (this.sort_action === 2) {
        this.query()
      }
    },
    confirm2 () {
      this.$refs.mdCheck.hide()
      if (this.sort_action === 2) {
        this.$parent.Loading = true
        return axios.post(API_URL + '/web/resort/leaflet/v1',{
            arrSort: this.new_items
          })
          .then((response) => {
            if (response.data.result) {
              miniToastr.success('餐點DM排序已變更')
              this.query()
              this.$store.commit('TOKEN', response.data.jwt)
            } else {
              console.log(response.data.message)
              miniToastr.error(response.data.message,'DM排序邊更失敗')
            }
            this.$parent.Loading = false
          })
          .catch((error) => {
            console.log(error)
            this.$parent.Loading = false
          })
      } else {
        this.query()
      }
    },
    showDetail (item) {
      this.md_imgUrl = item.ImageURL
      this.$refs.mdDetail.show()
    },
    showDelete (item) {
      this.md_id = item.ID
      this.md_title = item.Title
      this.$refs.mdDelete.show()
    },
    delCancel () {
      this.$refs.mdDelete.hide()
    },
    delConfirm () {
      this.$refs.mdDelete.hide()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/del/leaflet/v1',{
            id: this.md_id
      })
        .then((response) => {
          if (response.data.result) {
            miniToastr.success('餐點DM已刪除')
            this.query()
            this.$store.commit('TOKEN', response.data.jwt)
          } else {
            console.log(response.data.message)
            miniToastr.error(response.data.message,'刪除DM失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log(error)
          this.$parent.Loading = false
        })
    },
    setdate () {
      var date = new Date()
      date.setMonth(date.getMonth() - 3)
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.search.sdate = year + '-' + mon + '-' + day
      this.search.edate = ''
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v2", {
          all: false,
          order: false,
          menupage: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = d.getMonth() + 1
      if (mon < 10) {
        mon = "0"+mon
      }
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      return year + '/' + mon + '/' + day
    },
    formatFullDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = d.getMonth() + 1
       if (mon < 10) {
        mon = "0"+mon
      }
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      var sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min + ':' + sec
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/menu/List.vue